import type { ApolloError } from '@apollo/client';

import { EDIT, DELETE } from 'src/consts';
import type { AnalyticsActionOrigin } from 'src/modules/analytics/types';
import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import type { ActionName } from 'src/types';

import { type LicenceAction, Actions } from './actions';

export const updateLicence = (action: ActionName): LicenceAction => ({
  type: Actions.UPDATE_LICENCE_START,
  actionName: action,
  meta: {
    metrics: {
      action,
    },
  },
});

export const updateLicenceSuccess = (
  actionName: ActionName,
  analytics?: { actionOrigin?: AnalyticsActionOrigin },
): LicenceAction => ({
  type: Actions.UPDATE_LICENCE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
    analytics: {
      actionName,
      ...analytics,
    },
  },
});

export const updateLicenceFailure = (error: ApolloError): LicenceAction => ({
  type: Actions.UPDATE_LICENCE_FAILURE,
  payload: { error },
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateVerifiedLicence = (): LicenceAction => ({
  type: Actions.UPDATE_VERIFIED_LICENCE_START,
  meta: {
    metrics: {
      action: EDIT,
    },
  },
});

export const updateVerifiedLicenceSuccess = (): LicenceAction => ({
  type: Actions.UPDATE_VERIFIED_LICENCE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateVerifiedLicenceFailure = (
  error: ApolloError,
): LicenceAction => ({
  type: Actions.UPDATE_VERIFIED_LICENCE_FAILURE,
  payload: { error },
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const removeLicence = (): LicenceAction => ({
  type: Actions.REMOVE_LICENCE_START,
  actionName: DELETE,
});

export const removeLicenceSuccess = (): LicenceAction => ({
  type: Actions.REMOVE_LICENCE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const removeLicenceFailure = (error: ApolloError): LicenceAction => ({
  type: Actions.REMOVE_LICENCE_FAILURE,
  payload: { error },
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});
